import React from 'react';
import { ApiStore, Subscribe } from 'Store';

// Components
import { Header, Anchor } from 'Components/core';
import Card from 'Components/Card';
import CardContainer from 'Components/Card/CardContainer';

// Icons
import AlarmIcon from 'Icons/alarm.svg';
import MedkitIcon from 'Icons/medkit.svg';
import StethoscopeIcon from 'Icons/stethoscope.svg';
import CODES from 'Root/libs/analytics/CodeDef';

export default props => (
  <Subscribe to={[ApiStore]}>
    {state => (
      <CardContainer>
        <Card>
          <div>
            <img
              alt="Medkit"
              src={MedkitIcon}
              style={{ width: '4em', height: '4em' }}
            />
          </div>
          <Header>
            {state.includeMedical ? (
              <Anchor code={CODES.INTERNAL_MD} to="/benefits/medical" underline={false}>
                Explore your <br /> plan options
              </Anchor>
            ) : (
              <span>
                Explore your <br /> plan options
              </span>
            )}
          </Header>
          <p>Choose the right plan for you</p>
        </Card>
        <Card>
          <div>
            <img
              alt="Alarm"
              src={AlarmIcon}
              style={{ width: '4em', height: '4em' }}
            />
          </div>
          <Header>
            {typeof state.oeMaterials?.enrollURL === 'string' ? (
              <Anchor code={CODES.READY_TO_ENROLL} to={state.oeMaterials.enrollURL} underline={false}>
                Ready to enroll?
                <br />
                Get started
              </Anchor>
            ) : (
              <span>
                {' '}
                Ready to enroll?
                <br />
                Get started
              </span>
            )}
          </Header>
          {state?.oeMaterials?.enrollPara && (
            <p>{state.oeMaterials.enrollPara}</p>
          )}
        </Card>
        <Card>
          <div>
            <img
              alt="Stethoscope"
              src={StethoscopeIcon}
              style={{ width: '4em', height: '4em' }}
            />
          </div>
          <Header>
            <Anchor code={CODES.INTERNAL_HPW} to="/benefits/how-plan-works" underline={false}>
              Learn how <br /> your plan works
            </Anchor>
          </Header>
          <p>
            Common terms, how to choose a health plan and more.{' '}
            
            { state?.oeMaterials?.oeBrochure?.oeBrochureURL &&
            (state?.oeMaterials?.oeBrochure?.oeBrochureURL+"").length>0 &&
              <Anchor
                code={CODES.EBO_URL}
                to={state?.oeMaterials?.oeBrochure?.oeBrochureURL}
                underline={false}
              >
                Plus, view or download the Open Enrollment Booklet.
              </Anchor>
            }
          </p>
        </Card>
      </CardContainer>
    )}
  </Subscribe>
);
